import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "PassionSlider-item-left" }
const _hoisted_2 = { class: "PassionSlider-item-left-text h3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right-img" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/passion-0.png 1x, /images/home/passion-0@2x.png 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/passion-0.png",
        alt: "passion home"
      })
    ])
  ])
], -1)
const _hoisted_4 = { class: "PassionSlider-item-left" }
const _hoisted_5 = { class: "PassionSlider-item-left-text h3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right-img" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/passion-1.png 1x, /images/home/passion-1@2x.png 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/passion-1.png",
        alt: "passion home"
      })
    ])
  ])
], -1)
const _hoisted_7 = { class: "PassionSlider-item-left" }
const _hoisted_8 = { class: "PassionSlider-item-left-text h3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "PassionSlider-item-right-img" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/passion-2.png 1x, /images/home/passion-2@2x.png 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/passion-2.png",
        alt: "passion home"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StickyElement = _resolveComponent("StickyElement")!
  const _component_AppearObject = _resolveComponent("AppearObject")!

  return (_openBlock(), _createBlock(_component_AppearObject, {
    "data-sticky-container": "",
    class: "PassionSlider"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_StickyElement, { class: "PassionSlider-inner" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([{ 'is-active': _ctx.currentPassion === 0, 'is-prev': _ctx.currentPassion > 0 }, "PassionSlider-item grid padded"])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('home.description3a')), 1)
            ]),
            _hoisted_3
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'is-active': _ctx.currentPassion === 1, 'is-prev': _ctx.currentPassion > 1 }, "PassionSlider-item grid padded"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('home.description3b')), 1)
            ]),
            _hoisted_6
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'is-active': _ctx.currentPassion === 2 }, "PassionSlider-item grid padded"])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('home.description3c')), 1)
            ]),
            _hoisted_9
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}